import mapValuesToRequest, {
  IRequestBody,
} from './mappers/mapValuesToRequestProfile'
import handleResponse from './request/handleProfileResponse'

export default function(api: GlobalFetch) {
  return async function(data: IRequestValues) {
    const requestBody: IRequestBody = mapValuesToRequest(data)
    const response = await api.fetch(`/api/v2/object/index/`, {
      body: JSON.stringify(requestBody),
      method: 'PUT',
    })

    return await handleResponse(response)
  }
}

export interface IRequestValues {
  id: number
  idCurrency?: number
  idCountry?: number

  city?: string
  name?: string
  phone?: string
  postCode?: string
  street?: string

  swift?: string
  accountNumber?: string

  companyName?: string
  companyCountry?: number
  companyStreet?: string
  companyPostCode?: string
  companyCity?: string
  companyVatNumber?: string

  email?: string
  facebook?: string
  type?: number
  www?: string
}
